<template>
  <div class="main m-0 p-0" ref="containerRef">
    <CardIntroTutorial />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import CardIntroTutorial from "@/apps/credit-line/components/CreditCard/IntroTutorial.vue";
import { resizeComponentHelper } from "@/apps/credit-line/helpers/resizeComponent.helper";

const containerRef = ref<HTMLElement | null>(null);

onMounted(() => {
  resizeComponentHelper(containerRef);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
* {
  overflow-y: hidden !important;
}
</style>
